import { render, staticRenderFns } from "./ReportReferredRequests.vue?vue&type=template&id=131279bc&"
import script from "./ReportReferredRequests.vue?vue&type=script&lang=js&"
export * from "./ReportReferredRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports